module.exports = __webpack_public_path__ + "img/29ne.5d0494e3.svg";